const $ = jQuery.noConflict()

$.fn.extend({
  autocomplete: function () {
    self.init(this.selector)
  }
})

var self = module.exports = {
  options: {
    country: 'GB',
    types: ['geocode', 'establishment']
  },

  init: function (selector) {
    $(selector).each(function () {
      self.events.init(this)
    })
  },

  events: {
    init: function (field) {
      self.service.initField(field)
    }
  },

  service: {
    initField: function (field) {
      $(field).on('click', function (event) {
        var id = $(field).attr('id')
        var types = (typeof $(field).data('types') === 'undefined') ? self.options.types : $(field).data('types')
        var input = document.getElementById(id)
        var options = {
          types: types,
          componentRestrictions: {
            country: self.options.country
          }
        }

        var componentForm = {
          street_number: 'long_name',
          route: 'long_name',
          postal_town: 'long_name',
          country: 'long_name',
          postal_code: 'short_name'
        }
        // eslint-disable-next-line no-undef
        var autocomplete = new google.maps.places.Autocomplete(input, options)

        autocomplete.setFields(['address_component'])
        // eslint-disable-next-line no-undef
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          $(input).change()

          var place = autocomplete.getPlace()
          if (!place) {
            // Inform the user that a place was not found and return.
            return
          }

          document.querySelector('#filledInstantValuationAdd').style.display = 'block'

          try {
            // Get each component of the address from the place details,
          // and then fill-in the corresponding field on the form.
            for (var index = 0; index < place.address_components.length; index++) {
              var element = place.address_components[index]
              var addressType = element.types[0]
              //$('.property_val').find('.form-staged__next').trigger('click'); 
              // console.log(addressType);
              // console.log('element    '+ JSON.stringify(element));

              if (componentForm[addressType]) {
                var val = element[componentForm[addressType]]
                document.getElementById(
                  'property-valuation-' + addressType
                ).value = val

              }
            }
          } catch (error) {
            console.log('Google autocomplete error', error)
          }
          // end
        })

        // $(field).removeAttr('autocomplete')
        $(field).attr('autocomplete', 'chrome-off')
      })
    }
  }
}
